// extracted by mini-css-extract-plugin
export default {"iconContainer":"unavailable_iconContainer__HlQqi","fullView":"unavailable_fullView__-R7C9","shimmer":"unavailable_shimmer__OQ1hq"};